import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import TopTabbar from "../partials/TopTabbar";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import WalletService from '../../services/WalletService';
import 'react-toastify/dist/ReactToastify.css';
import Flags from "react-world-flags";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import LoadingSpinner from '../../utils/LoadingSpinner';

const walletNames = [
    "ORANGE_MONEY",
    "MTN_MOBILE_MONEY",
    "WAVE"
];

const countries = [
    { code: "CM", name: "Cameroun" },
    { code: "CI", name: "Côte d'Ivoire" },
    { code: "BJ", name: "Bénin" },
    { code: "BF", name: "Burkina Faso" },
    { code: "SN", name: "Sénégal" }  // Ajout du Sénégal
];

const WalletSettings = () => {
    const navigate = useNavigate();
    const [wallets, setWallets] = useState([]);
    const [filteredWallets, setFilteredWallets] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("Tous les pays");
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isViewEditModalOpen, setIsViewEditModalOpen] = useState(false);
    const [selectedWallet, setSelectedWallet] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [formValidated, setFormValidated] = useState(false);
    const [newWallet, setNewWallet] = useState({
        walletName: '',
        country: '',
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isCreating, setIsCreating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const currentUser = JSON.parse(localStorage.getItem('user'));
    const currentUsername = currentUser ? currentUser.username : '';

    const fetchWallets = async () => {
        try {
            const response = await WalletService.getAllWallets();
            setWallets(response);
            setFilteredWallets(response);
        } catch (error) {
            toast.error("Erreur lors du chargement des wallets.");
        } finally {
            setIsPageLoading(false);
        }
    };

    useEffect(() => {
        fetchWallets();
    }, []);

    const filterWallets = (country, searchTerm) => {
        setSelectedCountry(country);
        let filtered = wallets;
        if (country !== "Tous les pays") {
            filtered = wallets.filter((wallet) => wallet.country === country);
        }
        if (searchTerm) {
            filtered = filtered.filter((wallet) =>
                wallet.walletName.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredWallets(filtered);
    };

    const handleCreateWallet = async (e) => {
        e.preventDefault();
        const form = e.target;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setFormValidated(true);
            return;
        }
        setIsCreating(true);
        try {
            const walletData = { ...newWallet, userName: currentUsername };
            await WalletService.createWallet(walletData);
            toast.success("Wallet créé avec succès !");
            setIsCreateModalOpen(false);
            setNewWallet({ walletName: '', country: '' });
            fetchWallets();
        } catch (error) {
            toast.error("Erreur lors de la création du wallet.");
        } finally {
            setIsCreating(false);
        }
    };

    const handleUpdateWallet = async (e) => {
        e.preventDefault();
        const form = e.target;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setFormValidated(true);
            return;
        }
        setIsUpdating(true);
        try {
            const updatedWallet = { ...selectedWallet, userName: currentUsername };
            await WalletService.updateWallet(updatedWallet);
            toast.success("Wallet mis à jour avec succès !");
            setIsViewEditModalOpen(false);
            setIsEditMode(false);
            fetchWallets();
        } catch (error) {
            toast.error("Erreur lors de la mise à jour du wallet.");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleDeleteWallet = async (id) => {
        const confirmation = await Swal.fire({
            title: 'Êtes-vous sûr ?',
            text: "Cette action est irréversible.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        });
        if (confirmation.isConfirmed) {
            try {
                await WalletService.deleteWallet(id);
                toast.success("Wallet supprimé avec succès !");
                fetchWallets();
            } catch (error) {
                toast.error("Erreur lors de la suppression du wallet.");
            }
        }
    };

    // Fonction pour obtenir l'icône appropriée selon le type de wallet
    const getWalletIcon = (walletName) => {
        switch(walletName) {
            case "ORANGE_MONEY":
                return "assets/images/transfer-to-bank/orange.png";
            case "MTN_MOBILE_MONEY":
                return "assets/images/transfer-to-bank/mtn.png";
            case "WAVE":
                return "assets/images/transfer-to-bank/wave.png";
            default:
                return "assets/images/transfer-to-bank/wallet.png";
        }
    };

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des wallets..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />
                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="verify-number-top-content">
                                        <div className="back-btn mt-32" onClick={() => navigate(-1)}>
                                            <img src="assets/svg/header-white-icon.svg" alt="back-btn" />
                                        </div>
                                        <div className="header-title mt-32">
                                            <p>Paramétrages des Wallets</p>
                                        </div>
                                        <button
                                            className="btn btn-success mt-32"
                                            onClick={() => setIsCreateModalOpen(true)}
                                        >
                                            <i className="fas fa-plus me-2"></i> Ajouter un Wallet
                                        </button>
                                    </div>
                                    <div className="contact-search">
                                        <div className="input-group contact-searchbar">
                                            <div className="search-icon">
                                                <img src="assets/svg/search-icon.svg" alt="search-icon" />
                                            </div>
                                            <div className="seach-bar">
                                                <input
                                                    type="search"
                                                    placeholder="Rechercher un wallet"
                                                    className="form-control search-text"
                                                    id="search-input"
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                        filterWallets(selectedCountry, e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="verify-number-bottom">
                                <div className="container mb-35">
                                    <div className="nav nav-tabs custom-tab-contact" role="tablist">
                                        <button
                                            className={`nav-link ${selectedCountry === "Tous les pays" ? "active" : ""}`}
                                            onClick={() => filterWallets("Tous les pays", searchTerm)}
                                        >
                                            Tous les wallets
                                        </button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="link" className="nav-link dropdown-toggle">
                                                <i className="fas fa-filter me-2"></i>
                                                Filtrer
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {countries.map((country) => (
                                                    <Dropdown.Item
                                                        key={country.code}
                                                        onClick={() => filterWallets(country.name, searchTerm)}
                                                    >
                                                        <Flags code={country.code} style={{ width: "20px", marginRight: "10px" }} />
                                                        {country.name}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="container" style={{ marginTop: '82px' }}>
                                    {filteredWallets.length > 0 ? (
                                        filteredWallets.map((wallet) => (
                                            <div
                                                className="transfer-first d-flex align-items-center justify-content-between"
                                                key={wallet.id}
                                                onClick={() => {
                                                    setSelectedWallet(wallet);
                                                    setIsViewEditModalOpen(true);
                                                }}
                                                style={{
                                                    transition: 'transform 0.2s',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <div className="bank-img">
                                                    <img
                                                        src={getWalletIcon(wallet.walletName)}
                                                        alt="wallet-icon"
                                                        style={{ width: '60px', height: '60px' , borderRadius: 55, padding: 5,}}
                                                    />
                                                </div>
                                                <div className="bank-details" style={{ textAlign: 'left', width: '100%' }}>
                                                    <h2 style={{ textAlign: 'left', margin: 0 }}>{wallet.walletName}</h2>
                                                    <div className="bank-card d-flex align-items-center">
                                                        <Flags
                                                            code={countries.find(c => c.name === wallet.country)?.code || ""}
                                                            style={{ width: "20px", marginRight: "10px" }}
                                                        />
                                                        <span>{wallet.country}</span>
                                                    </div>
                                                </div>
                                                <div className="bank-active-sec">
                                                    <FaTrashAlt
                                                        size={20}
                                                        style={{ color: "red", cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDeleteWallet(wallet.id);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            <img src="assets/images/setting/no_data.png" alt="Aucun transfert"
                                                 style={{ width: '100px', marginBottom: '20px' }} />
                                            <p style={{ color: '#666', fontSize: '1.2em' }}>Aucun wallet trouvé</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Footer />
                            <Modal
                                show={isViewEditModalOpen}
                                onHide={() => setIsViewEditModalOpen(false)}
                                size="lg"
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header>
                                    <Modal.Title>
                                        {isEditMode ? 'Modifier le Wallet' : 'Détails du Wallet'}
                                    </Modal.Title>
                                    {!isEditMode && (
                                        <Button
                                            variant="primary"
                                            className="ms-auto"
                                            onClick={() => setIsEditMode(!isEditMode)}
                                        >
                                            <FaEdit /> Modifier
                                        </Button>
                                    )}
                                    <Button variant="close" onClick={() => setIsViewEditModalOpen(false)} />
                                </Modal.Header>
                                <Form
                                    noValidate
                                    validated={formValidated}
                                    onSubmit={handleUpdateWallet}
                                >
                                    <Modal.Body>
                                        <Form.Group controlId="walletName" className="form-floating mt-3">
                                            <Form.Select
                                                value={selectedWallet?.walletName || ''}
                                                onChange={(e) =>
                                                    setSelectedWallet({ ...selectedWallet, walletName: e.target.value })
                                                }
                                                disabled={!isEditMode}
                                                required
                                            >
                                                <option value="">Sélectionnez un type de wallet</option>
                                                {walletNames.map((name) => (
                                                    <option key={name} value={name}>
                                                        {name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Type de Wallet</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un type de wallet.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="country" className="form-floating mt-3">
                                            <Form.Select
                                                value={selectedWallet?.country || ''}
                                                onChange={(e) =>
                                                    setSelectedWallet({ ...selectedWallet, country: e.target.value })
                                                }
                                                disabled={!isEditMode}
                                                required
                                            >
                                                <option value="">Sélectionnez un pays</option>
                                                {countries.map((country) => (
                                                    <option key={country.code} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Pays</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un pays.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Modal.Body>
                                    {isEditMode && (
                                        <Modal.Footer>
                                            {!isUpdating && (
                                                <Button variant="secondary" onClick={() => setIsEditMode(false)}>
                                                    Annuler
                                                </Button>
                                            )}
                                            <Button variant="primary" type="submit" disabled={isUpdating}>
                                                {isUpdating ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        <span className="visually-hidden">Chargement...</span>
                                                    </>
                                                ) : (
                                                    'Sauvegarder'
                                                )}
                                            </Button>
                                        </Modal.Footer>
                                    )}
                                </Form>
                            </Modal>
                            <Modal
                                show={isCreateModalOpen}
                                onHide={() => setIsCreateModalOpen(false)}
                                size="lg"
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Créer un Wallet</Modal.Title>
                                </Modal.Header>
                                <Form
                                    noValidate
                                    validated={formValidated}
                                    onSubmit={handleCreateWallet}
                                >
                                    <Modal.Body>
                                        <Form.Group controlId="walletName" className="form-floating mt-3">
                                            <Form.Select
                                                value={newWallet.walletName}
                                                onChange={(e) => setNewWallet({ ...newWallet, walletName: e.target.value })}
                                                required
                                            >
                                                <option value="">Sélectionnez un type de wallet</option>
                                                {walletNames.map((name) => (
                                                    <option key={name} value={name}>
                                                        {name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Type de Wallet</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un type de wallet.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="country" className="form-floating mt-3">
                                            <Form.Select
                                                value={newWallet.country}
                                                onChange={(e) => setNewWallet({ ...newWallet, country: e.target.value })}
                                                required
                                            >
                                                <option value="">Sélectionnez un pays</option>
                                                {countries.map((country) => (
                                                    <option key={country.code} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Pays</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un pays.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        {!isCreating && (
                                            <Button variant="secondary" onClick={() => setIsCreateModalOpen(false)}>
                                                Annuler
                                            </Button>
                                        )}
                                        <Button variant="primary" type="submit" disabled={isCreating}>
                                            {isCreating ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Chargement...</span>
                                                </>
                                            ) : (
                                                'Ajouter'
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WalletSettings;